import { render, staticRenderFns } from "./NormalizedBarChart.vue?vue&type=template&id=ed20b786&scoped=true"
import script from "./NormalizedBarChart.vue?vue&type=script&lang=js"
export * from "./NormalizedBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed20b786",
  null
  
)

export default component.exports